import React from 'react';

const SvgUserAttributes = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M8 6a3 3 0 100 6 3 3 0 000-6zm4.594 1c.26.61.406 1.284.406 2h9V7h-9.406zm-.004 4a4.942 4.942 0 01-1.01 1.518c.441.135.845.301 1.235.482H22v-2h-9.41zM8 14c-3.278 0-6 1.429-6 3v1h12v-1c0-1.571-2.722-3-6-3zm7.346 1c.417.61.654 1.284.654 2h6v-2h-6.654z" />
  </svg>
);

export default SvgUserAttributes;
